import React, {
    useState,
    useEffect,
    useLayoutEffect,
    useCallback,
    useContext,
    useRef,
} from "react";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ContextMenu } from "primereact/contextmenu";
import { InputNumber } from "primereact/inputnumber";
import { TabView, TabPanel } from "primereact/tabview";

import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Skeleton } from "primereact/skeleton";
import { InputTextarea } from "primereact/inputtextarea";

import { InputNumerico } from "../../../isp._comun/iu/componentes/widgets/InputNumerico";
import { InputValorMonetario } from "../../../isp._comun/iu/componentes/widgets/InputValorMonetario";
import GlobalContext     from "../../../isp._comun/iu/contexto/GlobalContext";

import Dialogo         from "../../../isp._comun/iu/_principal/componentes/layouts/Dialogo";
import EliminarVentana from "../../../isp._iu.start.principal/reductores/acciones/widgets/EliminarVentana";
import { ModosOp }     from "../../../isp._comun/iu/_principal/constantesIuPrin";

import * as Action   from "../../reductores/acciones/dispatch/_ActionsDispatch";
import ActionItemSet from "../../reductores/acciones/ActionItemSet";
import SetTipoItem   from "../../reductores/acciones/dispatch/SetTipoItem";

import { EstadosItemLabel }   from "./žconstantesIuLayoutItems";
import * as ModelosDeCombos from "./ModeloDeCombos_Items";


const DialogoItemLayout = ({
    ventana,
    estadoDCF,
    dispatchDCF,
    registrarItemCommand,
    actualizarItemCommand,
    buscarUnSoloItemCommand,
}) => {
    const { dispatchPrincipal } = useContext(GlobalContext);

    // const isMounted = useRef(false);
    const inputnumeral = useRef(null);

    useEffect(() => {
        console.log("use effect se monto el componente padre ----");
        console.log(inputnumeral);
        // inputnumeral.current.maxLength=6;
    }, []);

    useEffect(() => {
        if (estadoDCF.flag.cargandoEntidad) {
            buscarUnSoloItemCommand.ejecutar(estadoDCF.domain.screen.idItem);
        }
        return () => {};
    }, [estadoDCF.flag.cargandoEntidad]);

    useEffect(() => {
        if (!estadoDCF.flag.procesandoComando) {
            return;
        }
        if (estadoDCF.flag.modoOperacion === ModosOp.CREAR) {
            registrarItemCommand.ejecutar();
            return () => {
                registrarItemCommand.cancelar();
            };
        }
        if (estadoDCF.flag.modoOperacion === ModosOp.MODIFICAR) {
            actualizarItemCommand.ejecutar();
            return () => {
                actualizarItemCommand.cancelar();
            };
        }

    }, [estadoDCF.flag.procesandoComando]);

    const cancelarClick = (eventoSynDom) => {
        dispatchPrincipal(new EliminarVentana(ventana));
        eventoSynDom.stopPropagation();
    };

    const header = {
        elementoReact: <p className="p-2 bg-gradient-to-r from-purple-100">Item</p>,
        enProgreso: estadoDCF.flag.procesandoComando,
    };

    const labelBotonAccion = (() => {
        if (estadoDCF.flag.modoOperacion === ModosOp.CREAR) return "Guardar";
        if (estadoDCF.flag.modoOperacion === ModosOp.OK) return "   OK    ";
        if (estadoDCF.flag.modoOperacion === ModosOp.MODIFICAR) return "Modificar";
    })();

    const footer = (
        <div>
            <Button
                label={labelBotonAccion}
                icon="pi pi-check"
                onClick={(eventoSynDom) => {
                    if (estadoDCF.flag.modoOperacion === ModosOp.CREAR) {
                        dispatchDCF(new Action.GuardarItem());
                        // registrarClienteAFacturar();
                        return;
                    }
                    if (estadoDCF.flag.modoOperacion === ModosOp.MODIFICAR) {
                        dispatchDCF(new Action.ActualizarItem());
                        // actualizarClienteAFacturar();
                        return;
                    }
                    if (estadoDCF.flag.modoOperacion === ModosOp.OK) {
                        cancelarClick(eventoSynDom);
                        return;
                    }
                }}
                loading={estadoDCF.flag.procesandoComando}
                iconPos="left"
                className="whitespace-pre"
            />
            <Button
                label="Cancelar"
                icon="pi pi-times"
                onClick={(eventoDom) => cancelarClick(eventoDom)}
                disabled={estadoDCF.flag.procesandoComando}
                // className="w-32"
            />
        </div>
    );

    let bloqueTipoDeItem = null;

    if(estadoDCF.flag.modoOperacion === ModosOp.CREAR){
        bloqueTipoDeItem = 
            <Dropdown
                value={estadoDCF.domain.screen.tipoItem}
                options={ModelosDeCombos.tiposItem}                          
                onChange={(e) => {
                    dispatchDCF(new SetTipoItem("tipoItem", e.value));
                }}
                className="p-0 w-full rounded-none"
                // panelClassName="p-0"
                // panelStyle={{ padding: 0 }}
                disabled={estadoDCF.flag.procesandoComando}
            />
    }else{
        const labelTipoItem = ModelosDeCombos.tiposItem.find((tipoItem)=>{
            if(tipoItem.value === estadoDCF.domain.screen.tipoItem)return true;
        });
        bloqueTipoDeItem = labelTipoItem.label;
    }

    let bloqueCampos = (
        <>
            <div className="mr-10">
                <div className="flex mb-2">
                    <div className="w-32 shrink-0">Tipo de Item : </div>
                    <div>    
                        <Dropdown
                            value={estadoDCF.domain.screen.tipoItem}
                            // options={ModelosDeCombos.tiposItem}
                            options={ModelosDeCombos.tiposItem.filter((itemCombo) => {
                                return estadoDCF.domain.screen.combos.tiposItem.includes(
                                    itemCombo.value
                                );
                            })}                          
                            onChange={(e) => {
                                dispatchDCF(new SetTipoItem("tipoItem", e.value));
                            }}
                            className="p-0 w-full rounded-none"
                            // panelClassName="p-0"
                            // panelStyle={{ padding: 0 }}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                    </div>
                </div>
                <div className="flex mb-2">
                    <div className="w-32 shrink-0">Nombre : </div>
                    <div className="pl-0">
                        <InputText
                            id="in"
                            value={estadoDCF.domain.screen.nombre}
                            className="p-0 w-full rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionItemSet("nombre", e.target.value)
                                    // new Action.SetNombres(e.target.value)
                                )
                            }
                            maxLength={40}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <small
                            id=""
                            className={estadoDCF.error.nomBlanc ? "mb-1.5 block p-error" : "hidden"}
                        >
                            Se requiere Nombres del Item.
                        </small>
                        <small
                            id=""
                            className={estadoDCF.error.nomMF ? "mb-1.5 block p-error" : "hidden"}
                        >
                            El formato del Nombre es incorrecto.
                        </small>
                    </div>
                </div>
                <div className="flex mb-0.5">
                    <div className="w-32 shrink-0">Descripcion : </div>
                    <div className="pl-0">
                        <InputTextarea
                            id="in"
                            value={estadoDCF.domain.screen.descripcion}
                            className="p-0 w-full rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionItemSet("descripcion", e.target.value)
                                    // new Action.SetNombres(e.target.value)
                                )
                            }
                            rows={4}
                            cols={31}
                            maxLength={200}
                            autoResize={false}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                    </div>
                </div>
            </div>
            <div>
                <div className="flex mb-2">
                    <div className="w-24">Precio : </div>
                    <div>
                        <InputValorMonetario
                            onChange={(e) => {
                                // console.log("---onChange--- InputNumerico en Dialog");
                                // const inputEntrante = e.value;
                                const decimalEntrante=e.valor;
                                if (decimalEntrante === null) {
                                    // if(inputEntrante===""){
                                    dispatchDCF(new ActionItemSet("precio", ""));
                                    return;
                                }

                                // const stringNumberEntrante = inputEntrante.toFixed(2);
                                dispatchDCF(new ActionItemSet("precio", decimalEntrante));
                            }}
                            valor={
                                estadoDCF.domain.screen.precio === ""
                                    ? null
                                    : estadoDCF.domain.screen.precio
                            }
                        />
                        <small
                            id=""
                            className={
                                estadoDCF.error.precioBlanc ? "mb-1.5 block p-error" : "hidden"
                            }
                        >
                            Se requiere Precio del Item.
                        </small>
                    </div>
                </div>
                <div className="flex mb-2">
                    <div className="w-24">Moneda : </div>
                    <div>
                        <Dropdown
                            value={estadoDCF.domain.screen.moneda}
                            options={ModelosDeCombos.monedas}
                            onChange={(e) => {
                                dispatchDCF(new ActionItemSet("moneda", e.target.value));
                                // dispatchDCF(new Action.SetTipoDoc(e.value));
                            }}
                            // placeholder="Selecciona un Tipo"
                            className="p-0 w-full rounded-none"
                            // panelClassName="p-0"
                            // panelStyle={{ padding: 0 }}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                    </div>
                </div>

                <div className="flex">
                    <div className="w-24 shrink-0">Unidad : </div>
                    <div className="pl-0">
                        <Dropdown
                            value={estadoDCF.domain.screen.udm}
                            options={ModelosDeCombos.udms.filter((itemCombo) => {
                                return estadoDCF.domain.screen.combos.udms.includes(
                                    itemCombo.value
                                );
                            })}
                            onChange={
                                (e) => dispatchDCF(new ActionItemSet("udm", e.target.value))
                                // dispatchDCF(new Action.SetSexo(e.value))
                            }
                            placeholder="Seleccionar..."
                            className="p-0 w-full rounded-none"
                            // panelClassName="p-0"
                            // panelStyle={{ padding: 0 }}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <small
                            id=""
                            className={
                                estadoDCF.error.sexoBlanc ? "mb-1.5 block p-error" : "hidden"
                            }
                        >
                            Se requiere elegir un Género.
                        </small>
                    </div>
                </div>
            </div>
        </>
    );

    let bloqueAtributos = null;

    if (estadoDCF.flag.cargandoEntidad) {
        bloqueAtributos = (
            <>
                <div className="flex flex-row justify-between">
                    <Skeleton width="45%" height="6rem"></Skeleton>
                    <Skeleton width="40%" height="6rem"></Skeleton>
                </div>
                <br></br>
                <br></br>
                <div>
                    <Skeleton width="100%" height="10rem"></Skeleton>
                </div>
            </>
        );
    } else {
        bloqueAtributos = (
            <>
                <div className="flex justify-between flex-wrap">{bloqueCampos}</div>
            </>
        );
    }

    return (
        <Dialogo
            ventana={ventana}
            cabecera={header}
            modal={estadoDCF.flag.modal}
            posicionZ={ventana.posicionZ}
            pie={footer}
            estilo={{ width: "48rem", minHeight: "35vh", top: "15vh", margin: "0" }}
        >
            <div className="flex justify-between">
                <div>
                    <div className="flex">
                        <div className="w-40">Id. de Item : </div>
                        <div>{estadoDCF.domain.screen.idItem}</div>
                    </div>
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>
                <div>
                    <div className="flex">
                        <div className="w-40 shrink-0">Fecha de Registro : </div>
                        <div>{estadoDCF.domain.screen.fechaReg}</div>
                    </div>
                    <div className="flex">
                        <div className="w-40">Estado : </div>
                        <div>{EstadosItemLabel[estadoDCF.domain.screen.estado]}</div>
                    </div>
                </div>
            </div>

            <hr className="my-3"></hr>

            {bloqueAtributos}
        </Dialogo>
    );
};

export default DialogoItemLayout;
